/**
 * Created by rlopez on 08/11/16.
 */

import $ from 'jquery';

import RestService from 'RestService.js';
import undoService from 'UndoService.js';
import eventBus from 'EventBus';
import NotificationService from 'NotificationService.js';
import textConstants        from 'TextConstants';
import constants    from 'Constants.js';
import listService      from 'ListService.js';
import util        from 'util/Util.js';

const ICON_EMPTY = constants.DB_ICON_EMPTY;

//==========================================================================================
// This singleton controller handles resizing a control by dragging its borders.
//==========================================================================================
class EmailServerController{

    constructor() {

    }

    createNew(mainView){
        this.addServer(mainView).then((emailServerId) => {
            undoService.add({
                undo: () => {
                    this.deleteServer(emailServerId);
                },
                redo: () => {
                    this.undeleteEmailServer(mainView,emailServerId );
                }
            }, textConstants.UNDO_NEW_EMAIL_SVR);
            util.setUndoRedoAccess();
        });
    }

    deleteServer(emailServerId){
        RestService.deleteEmailServer(emailServerId).then((response)=>{
            console.log("Email Server Delete",response);
            eventBus.trigger(constants.EV_DELETE_EMAIL_SERVER, emailServerId);
        }).catch((err)=> {
            console.log('Error Deleting Email Server', err);
            NotificationService.error('Error Deleting Email Server' + err.MESSAGE);
        });
    }

    addServer(mainView){
        return RestService.addEmailServer().then((data)=>{
            console.log("Add New Response",data);
            const emailServerId = data.RESULT.RESPONSE.EmailServerId;
            this.expandUpdatedEmailServerListAndDetailView(mainView,emailServerId);

            return emailServerId;
        }).catch((err)=> {
            console.log('Error Creating Email Server', err);
            NotificationService.error('Error Creating Email Server' + err.MESSAGE);
        });
    }

    undeleteEmailServer(mainView, emailServerId){
        return RestService.undeleteEmailServer(emailServerId).then((data)=>{
            if (listService.activeDashboardTab === 'settings'){                                
              this.expandUpdatedEmailServerListAndDetailView(mainView,emailServerId);
            }

            return emailServerId;
        }).catch((err)=> {            
            NotificationService.error('Error Creating Email Server' + err.MESSAGE);
        });
    }

    expandUpdatedEmailServerListAndDetailView(mainView,emailServerId,container){
        RestService.getEmailServers().then((data)=>{
            this.renderEmailServerItems(mainView,data,0,'EmailsGroup',constants.EMAIL_SERVERS_GROUP_CONTAINER);
            if(emailServerId) {
                $(constants.EMAIL_SERVERS_GROUP_CONTAINER).collapse('show');                
                    $('li[role="button"]').removeClass('bg-success');
                    $(`i[data-itemid="${emailServerId}"]`).parent('li').addClass('bg-success');
                    mainView.renderEmailServerDetailsView(emailServerId);                
            }
            else{
                mainView.cleanDetailView();
            }
        }).catch((err)=> {
            console.log('Error Retrieving updated email server list', err);
            NotificationService.error('Error Retrieving updated email server list' + err.MESSAGE);
        });
    }

    renderEmailServerItems(mainView,data,groupType,itemId,dataTarget){
        console.log("Emails Servers Data",data);
        var nodes = [];
        if (data) {
            let emailServers = data instanceof Array ? data : [data];
            listService.emailServers = emailServers;
            nodes = this.loadEmailServersFromResponse(emailServers);
        }
        else{
            nodes = [{
                nodeName: 'no items',
                url: '#',
                icon: ICON_EMPTY,
                id: 0,
                groupType: groupType,
                nodeType: '',
                hasChildren: false
            }]
        }

        var group = mainView.replaceGroupItemsInModel('settingsSections', 'Account Settings',itemId,nodes);


        mainView.addItemsToGroup(group, dataTarget);
    }

    loadEmailServersFromResponse(emailServers) {
        var nodes = [];

        for(let emailServer of emailServers) {
            nodes.push({
                nodeName: emailServer["@isDefault"] === "True" ? emailServer['@Name']+" (Default)":emailServer['@Name'],
                url: '#',
                icon: ICON_EMPTY,
                id: emailServer['@EmailServerId'],
                groupType: constants.SETTINGS_RESOURCES_EMAIL_SERVERS,
                nodeType: 'emailItem', //connection["@Type"],
                hasChildren: false,
                toggleIcon: ''
            });
        }
        return nodes;
    }
}

const emailServerController = new EmailServerController();
export default emailServerController;
